import React from "react";
import PropTypes from "prop-types";
import Tooltip from "@material-ui/core/Tooltip";

const DisabledTooltip = ({ children, disabled, text = "" }) => {
  return disabled ? <Tooltip title={text}>{children}</Tooltip> : children;
};

DisabledTooltip.propTypes = {
  /**
   * Indica si el botón está deshabilitado
   **/
  disabled: PropTypes.bool,
  /**
   * Texto para mostrar en un tooltip en caso de que el botón esté deshabilitado.
   * En caso de no haber texto, no se muestra el tooltip
   **/
  text: PropTypes.string,
};

export default DisabledTooltip;
